import React from 'react';
import styled from 'styled-components';
import ThumbUp from '@material-ui/icons/ThumbUp';
import ThumbDown from '@material-ui/icons/ThumbDown';
import { fontSize } from '../../../../../../../constants/text';
import { colors } from '../../../../../../../constants/colors';
import {
  FEEDBACK_NEGATIVE,
  FEEDBACK_POSITIVE,
} from '../../../../../../Account/Profile/Insurance/util/insuranceInsights';

const Root = styled.div.withConfig({ componentId: 'sc-k6wkpp-0' })`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: space-between;
  min-height: 240px;
  border-top: 4px solid ${colors.purpSizzurp};
  border-radius: 8px;
`;

const TopContent = styled.div.withConfig({ componentId: 'sc-k6wkpp-1' })`
  padding: 0 24px;
  flex-grow: 100;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: ${colors.white};
  border-radius: 0 0 8px 8px;
  cursor: pointer;
`;

const Header = styled.div.withConfig({ componentId: 'sc-k6wkpp-2' })`
  font-size: ${fontSize.small};
  color: ${colors.lightText};
  text-align: center;
  padding-top: 28px;
`;

const Title = styled.div.withConfig({ componentId: 'sc-k6wkpp-3' })`
  font-size: ${fontSize.mediumLarge};
  color: ${colors.squid};
  text-align: center;
`;

const Link = styled.div.withConfig({ componentId: 'sc-k6wkpp-4' })`
  font-size: ${fontSize.default};
  color: ${colors.blueJayWay};
  text-align: center;
  padding-bottom: 30px;
`;

const FeedbackBox = styled.div.withConfig({ componentId: 'sc-k6wkpp-5' })`
  background: ${
    // @ts-expect-error ts-migrate(2551) FIXME: Property 'greyDim' does not exist on type '{ fadeT... Remove this comment to see the full error message
    colors.greyDim
  };
  border-top: 1px solid ${colors.granite};
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: ${colors.mildGrey};
  border-radius: 0 0 8px 8px;
`;

const Feedback = styled.span.withConfig({ componentId: 'sc-k6wkpp-6' })`
  font-size: 13px;
  padding: 16px 0;
`;

const ThumbUpIcon = styled(ThumbUp).withConfig({ componentId: 'sc-k6wkpp-7' })`
  cursor: pointer;
  margin-right: 12px;
  &.iconSmall {
    font-size: 16px;
    color: ${colors.mildGrey};
  }
`;

const ThumbDownIcon = styled(ThumbDown).withConfig({ componentId: 'sc-k6wkpp-8' })`
  cursor: pointer;
  &.iconSmall {
    font-size: 16px;
    color: ${colors.mildGrey};
  }
`;

type OwnProps = {
  feedbackGiven: boolean;
  feedbackJustGiven: boolean;
  header?: string;
  onClickContent: (...args: any[]) => any;
  onClickThumb: (...args: any[]) => any;
  title: string;
};

// @ts-expect-error ts-migrate(2456) FIXME: Type alias 'Props' circularly references itself.
type Props = OwnProps & typeof View.defaultProps;

// @ts-expect-error ts-migrate(7022) FIXME: 'View' implicitly has type 'any' because it does n... Remove this comment to see the full error message
const View = (props: Props) => {
  const { feedbackGiven, feedbackJustGiven, header, onClickContent, onClickThumb, title } = props;
  return (
    <Root>
      <TopContent onClick={onClickContent}>
        <Header>{header}</Header>

        <Title>{title}</Title>

        <Link>Tell me more</Link>
      </TopContent>
      {!feedbackGiven && (
        <FeedbackBox>
          <Feedback>Are you interested in this?</Feedback>

          <span>
            <ThumbUpIcon
              classes={{ fontSizeSmall: 'iconSmall' }}
              fontSize="small"
              onClick={() => onClickThumb(FEEDBACK_POSITIVE)}
            />

            <ThumbDownIcon
              classes={{ fontSizeSmall: 'iconSmall' }}
              fontSize="small"
              onClick={() => onClickThumb(FEEDBACK_NEGATIVE)}
            />
          </span>
        </FeedbackBox>
      )}
      {feedbackJustGiven && (
        <FeedbackBox>
          <Feedback>Thanks for your feedback!</Feedback>
        </FeedbackBox>
      )}
    </Root>
  );
};

View.defaultProps = {
  header: '',
};

export default View;
